module.exports = "/_next/static/images/a760894cd53590d7604f3f5cd4b0bded-xpeer-fgts@3x.jpg.webp";